// extracted by mini-css-extract-plugin
export default {"value":"SecondOrder_value__2xthe","wrapper":"SecondOrder_wrapper__7-9hW"};